import Fade from '@mui/material/Fade';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import Accordion from '@mui/material/Accordion';
import List from '@mui/material/List';
import Box from '@mui/material/Box';
import AccordionSummary, { accordionSummaryClasses } from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router';

const iconStyles = {
    mr: 1, 
    verticalAlign: 'middle'
}


const FAQ = () => {
    const [expanded, setExpanded] = useState(false);
    const location = useLocation();

    const { t } = useTranslation();
    const sections = t('faq.sections', { returnObjects: true });

    const vaccinationStatusEn = "How can I confirm whether my child has received the HPV vaccine?";
    const vaccinationStatusVi = "Làm thế nào tôi có thể xác nhận được con mình đã tiêm vắc-xin HPV hay chưa?";

    useEffect(() => {     
        if (location.state && location.state.fromHomepage) {
            setExpanded(true);
        }
    }, [location.state])

    // Render lists, checking if they are nested or not
    const renderLists = (list) => {
        const res = [];
        for (let i = 0; i < list.length; i++) {
            let listItem = list[i];

            // Construct an anchor element if item contains a URL string
            if (typeof listItem === 'string' && listItem.includes('https://')) {
                const chunks = constructLink(listItem);
                if (chunks[2] && chunks[2].includes('https://')) {
                    const chunks2 = constructLink(chunks[2]);
                    listItem = (
                        <span>
                            {chunks[0]}
                            <span dangerouslySetInnerHTML={{__html: chunks[1]}}></span>
                            {chunks2[0]}
                            <span dangerouslySetInnerHTML={{__html: chunks2[1]}}></span>
                            {chunks2[2]}
                        </span>
                    );
                }
            }
            const dom = listItem.sub_items ? (
                <Accordion key={i} sx={{ margin: 0, padding: 0 }} elevation={0}>
                    <AccordionSummary
                        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
                        aria-controls="subitem-content"
                        id={`subitem-header-${i}`}
                        sx={{
                            flexDirection: 'row-reverse',
                            '& .MuiAccordionSummary-expandIconWrapper': {
                                mr: 0,
                            },
                            '& .MuiAccordionSummary-content': {
                                ml: 1,
                            },
                            [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]: {
                                transform: 'rotate(90deg)',
                            },
                        }}
                    >
                        <ListItem sx={{ display: 'list-item', width: '95%' }}>
                            <Typography component="span">{listItem.item || listItem}</Typography>
                        </ListItem>
                    </AccordionSummary>
                    <AccordionDetails sx={{ margin: 0, padding: 0, ml: 2 }}>
                        <List sx={{ padding: 0}}>
                            {renderLists(listItem.sub_items)}
                        </List>
                    </AccordionDetails>
                </Accordion>
            )
            : (
                 <ListItem key={i} sx={{ display: 'list-item', ml: 4, width: '95%' }}>
                    <FiberManualRecordIcon sx={{ ...iconStyles, fontSize: 'small' }} />
                    <Typography component="span">{listItem.item || listItem}</Typography>
                </ListItem>
            )
            res.push(dom);
        }
        return res;
    }

    const constructLink = (str) => {
        if (str.includes('https://')) {
            const idx = str.indexOf('https://');
            const endIdx = str.indexOf(' ', idx);
            const link = endIdx === -1 ? str.substring(idx) : str.substring(idx, endIdx);
            const startText = str.substring(0, idx);
            const endText = endIdx === -1 ? '' : str.substring(endIdx);
            const linkEl = `<a href='${link}' target='_blank' rel='noopener' style='color: rgb(91, 59, 140)'>${link}</a>`;
            return [startText, linkEl, endText];
        }
        return str;
    }

    return (
        <Fade in timeout={1000}>
            <div className='main'>
                <Typography variant='h4'>{t('faq.title')}</Typography>
                <Typography variant='subtitle1' sx={{ mt: 2, mb: 4 }}>{t('faq.description')}</Typography>
                {sections.map((section, idx) => {
                    return(
                        <Box key={idx} sx={{ mb: 2 }}>
                            <Typography variant='h5' sx={{ mb: 2, mt: 4 }}>{t('faq.section')} {idx + 1}: {section.title}</Typography>
                            {section.qa.map((item, idx) => {
                                if (item.answer_cont && item.answer_cont.includes('https://sites.northwestern.edu/milkievugroup/')) {
                                    const siteLink = "<a href='https://sites.northwestern.edu/milkievugroup' target='_blank' rel='noopener' style='color: rgb(91, 59, 140)'>sites.northwestern.edu/milkievugroup</a>";
                                    item.answer_cont = item.answer_cont.replace('https://sites.northwestern.edu/milkievugroup/', siteLink);
                                }

                                if (item.question === vaccinationStatusEn || item.question === vaccinationStatusVi) {
                                    const questionLink = `<div id="vaccination-status"><a href="#vaccination-status" style="text-decoration: none; color: black;">${item.question}</a></div>`;
                                    item.question = questionLink;
                                }
                                return(
                                    <Accordion 
                                        key={idx} 
                                        sx={{ mb: 2}} 
                                        // expanded={(item.question.includes(vaccinationStatusEn) || item.question.includes(vaccinationStatusVi)) && expanded}
                                    >
                                        <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls={`panel-content-${idx}`}
                                        id={`panel-header-${idx}`}
                                        >
                                        <Typography component="span" sx={{ fontWeight: 600 }} dangerouslySetInnerHTML={{__html: item.question}}></Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>{item.answer}</AccordionDetails>
                                        {item.list && (
                                            <List>
                                                {renderLists(item.list.items)}
                                            </List>
                                        )}
                                        <Typography sx={{ margin: '0 1rem 1rem 1rem' }} dangerouslySetInnerHTML={{__html: item.answer_cont}}></Typography>
                                    </Accordion>
                                )
                            })
                            }
                        </Box>
                    )
                })}
            </div>
        </Fade>
    )
}

export default FAQ;